import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c365de0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Decrement = _resolveComponent("Decrement")!
  const _component_Increment = _resolveComponent("Increment")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['wrapper', { error: !_ctx.stringIsValid }])
  }, [
    _createElementVNode("input", {
      class: "number",
      type: "text",
      value: _ctx.stringValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event.target.value)))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange(_ctx.modelValue - 1)))
      }, [
        _createVNode(_component_Decrement)
      ]),
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChange(_ctx.modelValue + 1)))
      }, [
        _createVNode(_component_Increment)
      ])
    ])
  ], 2 /* CLASS */))
}